module.exports = __webpack_public_path__ + "img/247-motown.93388d1c.png";